import { render } from "./StyleEdit.vue?vue&type=template&id=c7f51fa2"
import script from "./StyleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./StyleEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Inventory/StyleEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7f51fa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7f51fa2', __exports__)) {
    api.reload('c7f51fa2', __exports__)
  }
  
  module.hot.accept("./StyleEdit.vue?vue&type=template&id=c7f51fa2", () => {
    api.rerender('c7f51fa2', render)
  })

}


export default __exports__